<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1398647" style="color: #82a339"><b>MINI REMOULADE CRAB CAKES</b></p>
<p class="ext" id="d7e1399147"><b><i>Crab cakes are a universal favorite. These luscious morsels can be prepared up to several hours ahead and refrigerated. Reheat just before serving.</i></b></p>
<p class="h4" id="d7e1400447" style="color: #496210"><b>Prep: 25 minutes      Bake: 20 minutes</b></p>
<p class="ul" id="d7e1400947">2 tablespoons butter or margarine</p>
<p class="ul" id="d7e1401247">1 small onion, finely chopped</p>
<p class="ul" id="d7e1401547">½ red pepper, finely chopped</p>
<p class="ul" id="d7e1402447">1 stalk celery, finely chopped</p>
<p class="ul" id="d7e1402847">¼ cup light mayonnaise</p>
<p class="ul" id="d7e1403747">1 tablespoon sour cream</p>
<p class="ul" id="d7e1404047">2 teaspoons grainy Dijon mustard</p>
<p class="ul" id="d7e1404347">½ teaspoon freshly grated lemon peel</p>
<p class="ul" id="d7e1405347">¼ teaspoon salt</p>
<p class="ul" id="d7e1406247">⅛ teaspoon ground red pepper (cayenne)</p>
<p class="ul" id="d7e1407247">1 pound lump crabmeat, picked over</p>
<p class="ul" id="d7e1407547">1 cup fresh bread crumbs (about 2 slices bread) <br/> <a class="hlink" href="#/Text/West_9781618371621_epub_c39_r1#d7e1416347">Lemon Sauce</a></p>
<p class="pub" id="d7e1408347" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 10-inch skillet, melt butter over medium heat. Add onion, red pepper, and celery. Cook, stirring frequently, until vegetables are tender, about 10 minutes. Let cool.</p>
<p class="pub" id="d7e1410447"><span style="color: #c15b49"><b>2.</b></span> In large bowl, stir mayonnaise, sour cream, mustard, lemon peel, salt, and ground red pepper until blended; stir in crabmeat and bread crumbs just until mixed. Cover and refrigerate 30 minutes.</p>
<p class="pub" id="d7e1412147"><span style="color: #c15b49"><b>3.</b></span> Meanwhile, prepare Lemon Sauce.</p>
<p class="pub" id="d7e1412847"><span style="color: #c15b49"><b>4.</b></span> Preheat oven to 400°F. Lightly grease two cookie sheets. Drop level tablespoons crab mixture, pressing lightly, on prepared cookie sheets. Bake until golden brown, about 15 minutes. Top each crab cake with about ½ teaspoon lemon sauce. Serve hot. Makes about 50 mini crab cakes.</p>
<p class="h4l" id="d7e1416347" style="color: #496210"><b>LEMON SAUCE</b></p>
<p class="tx4" id="d7e1416847">In small bowl, stir together <b>¼ cup light mayonnaise, ¼ cup sour cream, 1 teaspoon freshly grated lemon peel, 1 tablespoon fresh lemon juice, pinch salt, </b>and <b>pinch ground red pepper (cayenne) </b>until blended. Makes about ½ cup.</p>
<p class="ntx" id="d7e1421747">Each crab cake with sauce: About 28 calories, 2g protein, 1g carbohydrate, 2g fat (1g saturated), 12mg cholesterol, 71mg sodium.</p>
<p class="h4l" id="d7e1423047" style="color: #496210"><b>MAIN-DISH CRAB CAKES</b></p>
<p class="tx4" id="d7e1423547">Prepare crab cakes but divide crab mixture into 8 portions, about ½ cup each, and shape each into a 3-inch cake. Place on greased cookie sheet. Bake until golden brown, about 20 minutes, gently turning cake over with spatula halfway through baking. Serve with Lemon Sauce, if desired.</p>
<p class="ntx" id="d7e1426647">Each crab cake: About 138 calories, 12g protein, 5g carbohydrate, 7g fat (3g saturated), 68mg cholesterol, 366mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c39_r1.vue?4e7db6e4